<template>
                <tr>
                  <td class="ta_c fst"><a :href="`kwtp://uscode=${item.kwSymbol}`">{{item.symbol}}</a></td>
                  <td :title="`${item.kwName}`"><span class="obj">{{item.kwName}}</span></td>
                  <td class="ta_r">{{item.surpValue}}</td>
                  <td :class="`ta_r ${item.cssName}`">{{item.surpRatio}}</td>
                  <td class="ta_c">{{item.fqDate}}/{{item.fiscalFlag}}</td>
                  <td class="ta_r">{{item.revenue}}</td>
                  <td class="ta_r">{{item.operIncome}}</td>
                  <td class="ta_r">{{item.netIncome}}</td>
                  <td class="ta_r">{{item.revenue1y}}</td>
                  <td class="ta_r">{{item.opIncome1y}}</td>
                  <td class="ta_r">{{item.netIncome1y}}</td>
                  <td class="ta_c">{{item.filingDate}} </td>
                  <td class="ta_c lst">
                    <div v-if="item.newsSn" class="divOpenCss">
                      <a href="javascript:;" @click="openDiv(`ly${item.newsSn}`)" :class="{'p_sum act': chkId === `ly${item.newsSn}`,'p_sum':chkId !== `ly${item.newsSn}`}" :data-Layer-Id="`ly${item.newsSn}`">요약</a>
                      <div :id="`ly${item.newsSn}`" :class="{'p_sum_w act': chkId === `ly${item.newsSn}`,'p_sum_w':chkId !== `ly${item.newsSn}`}">
                        <div class="top">{{item.nvo.title}}</div>
                        <!-- //top -->
                        <div class="txt">
                            <textarea cols="30" rows="10" v-html="item.nvo.contents" readonly></textarea>
                        </div>
                        <!-- //txt -->
                        <div class="close">
                            <a href="javascript:;" @click="closeDiv"><em>X</em><span>닫기</span></a>
                        </div>
                        <!-- //close -->
                      </div>
                    </div>
                    <div v-else>
                      -
                    </div>
                  </td>
                </tr>
</template>

<script>
import { EventBus } from '@/store/event-bus'
export default {
  data () {
    return {
      pageNo: 1,
      chkId: undefined
    }
  },
  props: {
    item: Object
  },
  methods: {
    openDiv (idName) {
      if (this.chkId === idName) {
        let layerId = '#' + this.chkId
        $(layerId).fadeOut()
        this.chkId = undefined
      } else {
        let layerId = '#' + idName
        this.chkId = idName
        $(layerId).fadeIn()
      }
    },
    closeDiv () {
      let layerId = '#' + this.chkId
      $(layerId).fadeOut()
      this.chkId = undefined
    }
  },
  created () {
    EventBus.$on('pageNo', (val) => {
      this.pageNo = val
    })
  },
  computed: {
    getPageNo () {
      return this.pageNo
    }
  },
  watch: {
    getPageNo (val, oldVal) {
      if (val !== oldVal) {
        this.closeDiv()
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/kiwoom/usRecord/pc/Arecord_sub.vue